module.exports = __webpack_public_path__ + "img/16.1fdbea7e.png";